import axios from 'axios';
import { toErrorPage } from '@/assets/module/toErrorPage';

export const apiCall = async(url, body, header) => {
  let headerArray = {};
  if (header) {
    headerArray = header;
  }
  let idToken = sessionStorage.getItem('frUserIdToken');
  headerArray['Authorization'] = idToken;

  const instance = axios.create({
    // api call時の共通の仕様(timeoutを設定するかは未確認)
    // timeout: 2000,
    headers: headerArray
  });

  try {
    const res = await instance.post(url, body);
    console.log('apiCall response: ', res);
    return res.data;
  } catch (e) {
    console.error('apiCall error: ', e);
    console.error('errorStatus: ', e.response.status);
    if (e.response.status === 401 || e.response.status === 403) { // authorizerによる認証失敗
      // セッションストレージを初期化(期限切れの各トークンを全て削除)
      sessionStorage.clear();
      // タイムアウト画面へ
      return toErrorPage('timeout');
    } else { // 上記以外
      // 500エラー画面へ
      return toErrorPage('500');
    }
  }
};